// +----------------------------------------------------------------------
// | 大屏3D地图
// +----------------------------------------------------------------------

import * as echarts from "echarts";
import * as turf from "@turf/turf";
import "echarts-gl";

export function geoMapA(that, GQDW) {
  //如果是市县权限账号提示市县名字，如果是街道提示街道名字
  if (that.$getCityFuqin("level") == 4) {
    var authName = that.$getCityFuqin("name");
    GQDW = GQDW.map((item, index) => {
      if (index === 0) {
        return { ...item, name: that.$getUser("districtName") };
      }
      return item;
    });
  } else {
    var authName = "";
  }

  // 创建map
  const mapElement = document.getElementById("geoMapA");
  if (!mapElement) {
    console.error("Map element not found");
    return;
  }
  const myChartmap = echarts.init(mapElement);
  if (myChartmap) {
    myChartmap.clear();
  }

  // 颜色映射表
  const colorMapping = {
    0: "#2b339a",
    1: "#2e40a3",
    2: "#304ead",
    3: "#335eb8",
    4: "#366ec3",
    5: "#397dce",
    6: "#41a9ed",
  };

  const regions = GQDW.map((item) => ({
    name: item.name,
    itemStyle: {
      borderWidth: 5,
      borderColor: "#5EC6EB",
      color: colorMapping[item.number] || "#41a9ed",
    },
  }));

  // 获取并验证城市代码
  const provinceCode = that.$FMTCode(that.$getUser("provinceCode"));
  const cityCode = that.$FMTCode(that.$getUser("cityCode"));

  const districtName = that.$getUser("districtName");

  const level = that.$getUser("level");
  try {
    var mapJson = require(`@/assets/json/geojson/${provinceCode}/${cityCode}.json`);
    if (level > 2) {
      const districtCode = that.$FMTCode(that.$getUser("districtCode"));
      const targetDistrictName = districtName;
      // 使用Turf.js过滤特定行政区划
      var mapJson = turf.featureCollection(mapJson.features.filter((feature) => feature.properties.name === targetDistrictName));
    }
    echarts.registerMap(that.$getCityFuqin("name"), mapJson);

    //视角控制配置
    const viewControl = {
      projection: "perspective",
      autoRotateDirection: "cw",
      distance: 180,
      minDistance: 20,
      maxDistance: 200,
      alpha: 40,
      beta: -15,
      center: [-5, -20, 0],
    };

    const option = {
      tooltip: {
        trigger: "item",
        formatter: (params) => `
          <h1 style='font-size:17px;font-weight:700;'>${params.data.name + authName}</h1>
          (排)排放工地：${params.data.PFGD}个<br/>
          (收)临时堆放：${params.data.JSDW100}个<br/>
          (收)资源利用：${params.data.JSDW200}个<br/>
          (收)分拣中心：${params.data.JSDW300}个<br/>
          (收)工程回填：${params.data.JSDW400}个<br/>
          (收)装卸码头：${params.data.JSDW500}个<br/>
          (收)跨市处理：${params.data.JSDW600}个<br/> 
          (收)移动收集：${params.data.JSDW700}个<br/>
        `,
        extraCssText: `
          background-color: rgba(10, 34, 171, 0.9);
          border: 2px solid rgba(2, 22, 137, 0.5);
          border-radius: 4px;
          line-height:1.8;
          font-size:15px;
          padding: 10px;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.8);
          text-align: left;
        `,
      },

      geo3D: {
        type: "map3D",
        name: "地图",
        shading: "realistic",
        realisticMaterial: {
          detailTexture: require("@/assets/mapbg.png"),
        },
        regions,
        zlevel: 2,
        regionHeight: 5,
        map: that.$getCityFuqin("name"),
        label: {
          show: false,
        },
        itemStyle: {
          color: "#fff",
          borderWidth: 2,
          borderColor: "rgba(0, 192, 255)",
        },
        emphasis: {
          label: {
            show: false,
          },
          itemStyle: {
            color: "rgba(0, 192, 255)",
          },
        },
        light: {
          main: {
            color: "#00d2ff",
            intensity: 1.1,
            shadow: true,
            alpha: 55,
            beta: 30,
          },
          ambient: {
            color: "#fff",
            intensity: 0.5,
          },
        },
        viewControl,
      },

      series: [
        {
          type: "map3D",
          name: "统计数据",
          shading: "realistic",
          zlevel: 3,
          regionHeight: 5,
          map: that.$getCityFuqin("name"),
          label: {
            show: true,
            formatter: function (e) {
              return e.name + authName;
            },
            distance: 0,
            textStyle: {
              color: "#fff",
              fontFamily: "苹方",
              fontSize: 20,
            },
          },
          itemStyle: {
            color: "transparent",
          },
          emphasis: {
            label: {
              show: true,
            },
            itemStyle: {
              color: "transparent",
            },
          },
          viewControl,
          data: GQDW,
        },
      ],
    };

    myChartmap.setOption(option);

    // 添加点击事件监听器
    myChartmap.on("click", function (params) {
      console.log(params);
      const code = encodeURIComponent(params.data.code);
      that.$QHopen.url("/map?keyword=" + params.data.name, 1300);
    });
  } catch (error) {
    console.error("Error loading map JSON or initializing chart:", error);
  }
}
